<template>
  <div class="container">
      <div class="row margin-top">
  <div class="col">
    <div class="d-grid gap-1">
      <!-- <button type="button" class="btn btn-success" style="height: auto;" data-bs-toggle="collapse" data-bs-target="#collapse-b1" aria-expanded="false" aria-controls="collapse-b1">
        Button 1
      </button> -->

      <div class="card" data-bs-toggle="collapse" data-bs-target="#collapse-b1" aria-expanded="false" aria-controls="collapse-b1">
        <div class="card-body">
          This is some text within a card body.
        </div>
      </div>

    </div>
  </div>

  <!-- <div class="col">
    <div class="d-grid gap-2">
      <button type="button" class="btn btn-primary" style="height: auto;" data-bs-toggle="collapse" data-bs-target="#collapse-b2" aria-expanded="false" aria-controls="collapse-b2">
        Button 2
      </button>
    </div>
  </div> -->

</div>

<div id="myGroup">  <!-- Add the parent id here -->

  <div class="collapse" id="collapse-b1"  data-bs-parent="#myGroup">
    <div class="alert alert-success mt-3">
      Text 1
    </div>
  </div>

  <div class="collapse" id="collapse-b2" data-bs-parent="#myGroup">
    <div class="alert alert-primary mt-3">
      Text 2
    </div>
  </div>
  
</div>

    
  </div>
</template>

<script lang="ts">

//import { fetchWrapper } from '@/helpers';

export default {
  name: 'configuration-plan-summary',
  components: {},
  data() {
    return {}
  },
  methods: {
    
  },
  mounted() {
    
  }
}
</script>